"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDashCase = exports.dashCaseToCamelCase = void 0;

var toDashCase = function toDashCase(text) {
  return text.trim().toLowerCase().replace(/ {1,}/g, '-');
};

exports.toDashCase = toDashCase;

var dashCaseToCamelCase = function dashCaseToCamelCase(text) {
  var lowercaseText = text.toLowerCase();
  return lowercaseText.replace(/-([a-z])/g, function (group) {
    return group[1].toUpperCase();
  });
};

exports.dashCaseToCamelCase = dashCaseToCamelCase;